export const FETCH_ALL_CAMPAIGNS = 'FETCH_ALL_CAMPAIGNS';
export const FETCH_ALL_CAMPAIGNS_SUCCEDD = 'FETCH_ALL_CAMPAIGNS_SUCCEDD';
export const FETCH_ALL_CAMPAIGNS_FAILED = 'FETCH_ALL_CAMPAIGNS_FAILED';
